import { Subject } from 'rxjs';

export class AuthEventEmitter extends Subject<any>{
    constructor() {
        super();
    }
    emit(value) { super.next(value); }
}